import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import axios from 'axios';
import './reachout.css';

const ReachOut = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.name && formData.email && formData.message) {
      try {
        await axios.post('https://script.google.com/macros/s/AKfycbyO6fKq-YrEj8rrRt2zEJDVnjm59s2ucH8Rt32Fdd4a0Q6-ubD4iop3yDQVjVkEgHfdzw/exec', formData, {
          
        });
        setSuccess(true);
        setError(false);
        setFormData({ name: '', email: '', phone: '', message: '' });

      } catch (err) {
        console.error(err);
        setSuccess(false);
        setError(true);
      }
    } else {
      setSuccess(false);
      setError(true);
      
    }
  };

  return (
    <Container className="py-5">
      {/* <h1 className="text-center mb-4">REACH OUT</h1> */}

      {/* <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="formName">
          <Form.Label>
            Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formEmail">
          <Form.Label>
            Email Address <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="email"
            name="email"
            placeholder="Enter your email address"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formPhone">
          <Form.Label>Phone</Form.Label>
          <Form.Control
            type="tel"
            name="phone"
            placeholder="Enter your phone number"
            value={formData.phone}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formMessage">
          <Form.Label>
            Message <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            name="message"
            placeholder="Tell us more about your inquiry"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Button type="submit" variant="danger">
          Submit
        </Button>

        {success && (
          <Alert variant="success" className="mt-3">
            Thank you! Your submission has been received!
          </Alert>
        )}
        {error && (
          <Alert variant="danger" className="mt-3">
            Oops! Please fill all required fields or check your network connection.
          </Alert>
        )}
      </Form> */}


            <Row className="mt-5">
              <Col>                
                <div className="ratio ratio-4x3">
                <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdcMdO4Fxb0lrzIHuXdwVWLJeHil6bROgvka0h0_RctH54-2g/viewform?embedded=true" 
                width="640" height="580" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                </div>
              </Col>
            </Row>

      {/* Contact Info & Map */}
      <Row className="mt-5">
        <Col md={6} className="mb-4">
          <h5 className="fw-bold">GAMMADDA</h5>
          <p>P.O. Box 929,<br />Colombo, Sri Lanka</p>
          <p><strong>PHONE</strong><br />+94 114 896 896 (Gammadda Hotline)<br />+94 777 600 020 (V-Force Hotline)</p>
          <p><strong>EMAIL</strong><br /><a href="mailto:info@gammadda.lk">info@gammadda.lk</a></p>
        </Col>
        <Col md={6}>
          <div className="ratio ratio-4x3">
            <iframe
              title="Gammadda Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.763173798846!2d79.8569414!3d6.9188914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2596b48b8fa87%3A0xf39be1d629b6b6c1!2sGammadda!5e0!3m2!1sen!2slk!4v1747810865664!5m2!1sen!2slk"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ReachOut;
